import styled from 'styled-components';

const Reviews = styled.section`
  background-color: ${({ theme }) => theme.color.darkBlue};
  margin-bottom: 50px;

  .row {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .heading {
    font-family: 'Poppins', sans-serif;
    width: 60%;
    padding: 100px 0 30px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 100%;
    }
    h3 {
      color: ${({ theme }) => theme.color.lightBlue};
      font-weight: 500;
    }
    h1 {
      color: #fff;
      font-size: 3.5rem;
      line-height: 1.4;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        font-size: 2.5rem;
      }
    }
  }

  .carousel-container {
    display: flex;
    align-items: center;
    height: 450px;
    overflow: hidden;
    position: relative;
    width: 100%;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      max-width: 100%;
    }

    .carousel-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: #333;
      color: white;
      border: none;
      padding: 10px 15px;
      cursor: pointer;
      border-radius: 50%;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        background: #fff;
        color: #000;
        top: 95%;
        transform: translateY(-95%);
      }
    }

    .carousel-button:hover {
      background: #555;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        background: ${({ theme }) => theme.color.lightBlue};
      }
    }

    .left-button {
      left: 10px;
    }

    .right-button {
      right: 10px;
    }

    .carousel {
      display: flex;
      gap: 30px;
      justify-content: flex-start;
      transition: transform 0.5s ease-in-out;
      transform: translateX(${({ offsetRev }) => `-${offsetRev * 330}px`});
    }
    .card {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      overflow: hidden;
      flex: 0 0 380px; /* fixed // width: 380px, no shrink, no grow */
      height: 350px;
      position: relative;

      img {
        position: absolute;
        top: 0;
        height: 300px;
        width: 100%;
        border-radius: 30px;
        object-fit: cover;
      }

      .content {
        padding: 20px;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 50%;
        border-radius: 30px;
        background-color: #fff;
        width: 100%;

        .content_header {
          margin-bottom: 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;

          .plusIcon {
            color: ${(props) => props.theme.color.lightBlue};
            font-size: 1.5rem;
          }
        }

        p{
        font-size: 0.8rem;
        line-height: 1.5;
        opacity: .7;}
      }
    }
  }
`;
export { Reviews };
